import React, { useState, useEffect } from 'react';
import { Zap, BookOpen, LineChart, ClipboardList, Layers, Settings, Key,
  Activity, TrendingUp, Table2, Radio, Percent, Gauge, BarChart3, Waves, Compass, LayoutDashboard, CandlestickChart, Crosshair
} from 'lucide-react';

var NAV = [
  { id: 'dashboard',   label: 'Home',       Icon: LayoutDashboard, section: 'overview' },
{ id: 'workspace',   label: 'Workspace',       Icon: LayoutDashboard, section: 'overview' },
  { id: 'jpsignal',    label: 'Signal',     Icon: Radio,         section: 'strategy' },
  { id: 'quantiply',   label: 'Quantiply',  Icon: Zap,           section: 'strategy' },
  { id: 'amb',         label: 'AMB',        Icon: Activity,      section: 'strategy' },
  { id: 'amb2',        label: 'AMB2',       Icon: Activity,      section: 'strategy' },
  { id: 'amb3',        label: 'AMB3',       Icon: Activity,      section: 'strategy' },
  { id: 'super_straddle',   label: 'SS1',  Icon: Activity,      section: 'strategy' },
  { id: 'super_straddle_2', label: 'SS2',  Icon: Activity,      section: 'strategy' },
  { id: 'super_straddle_3', label: 'SS3',  Icon: Activity,      section: 'strategy' },
  { id: 'hybrid',      label: 'Hybrid',     Icon: Gauge,         section: 'market' },
  { id: 'gex',         label: 'GEX',        Icon: BarChart3,     section: 'market' },
  { id: 'positioning', label: 'Position',   Icon: Compass,       section: 'market' },
  { id: 'oi',          label: 'OI',         Icon: BarChart3,     section: 'market' },
  { id: 'oiride',      label: 'OI Ride',    Icon: Waves,         section: 'market' },
  { id: 'oirided',     label: 'OI Ride D',  Icon: Waves,         section: 'market' },
  { id: 'oirided1',    label: 'OI Ride D-1', Icon: Waves,        section: 'market' },
  { id: 'oirider',     label: 'OI Ride-R',  Icon: Waves,        section: 'market' },
  { id: 'paper_journal', label: 'Paper Jrnl', Icon: ClipboardList,      section: 'market' },
  { id: 'oiwalls',     label: 'OI Walls',   Icon: Layers,        section: 'market' },
  { id: 'oiwalls3x',   label: 'OI Walls 3x', Icon: Layers,       section: 'market' },
  { id: 'oiwalls2x',   label: 'OI Walls 2X', Icon: Layers,       section: 'market' },
  { id: 'oiwalls_live', label: 'Walls LIVE', Icon: Layers,        section: 'market' },
  { id: 'oiwalls3x_live', label: 'Walls3x LIVE', Icon: Layers,    section: 'market' },
  { id: 'gexwalls_live', label: 'GWalls LIVE', Icon: Crosshair,     section: 'market' },
{ id: 'oiride_d_live', label: 'GWalls LIVE', Icon: Crosshair,     section: 'market' },
{ id: 'oiride_r_live', label: 'OI Ride-R LIVE', Icon: Crosshair, section: 'market' },
{ id: 'directional_tv', label: 'Directional TV', Icon: TrendingUp, section: 'market' },
{ id: 'directional_tv1', label: 'Directional TV-1', Icon: TrendingUp, section: 'market' },
  { id: 'gexwalls',    label: 'GEX Walls',  Icon: Crosshair,     section: 'market' },
  { id: 'straddle',    label: 'Strad',      Icon: Waves,         section: 'market' },
  { id: 'optionchain', label: 'OC',         Icon: Table2,        section: 'market' },
  { id: 'ivsurface',   label: 'IV',         Icon: LineChart,     section: 'market' },
  { id: 'journal',     label: 'Journal',    Icon: BookOpen,      section: 'market' },
  { id: 'logs',        label: 'Logs',       Icon: BookOpen,      section: 'system' },
  { id: 'orders',      label: 'Orders',     Icon: ClipboardList, section: 'system' },
  { id: 'token',       label: 'Token',      Icon: Key,           section: 'system' },
  { id: 'settings',    label: 'Settings',   Icon: Settings,      section: 'system' },
];

var SECTION_COLORS = {
  overview: '#10b981',
  strategy: '#0ea5e9',
  market: '#a78bfa',
  system: '#556677',
};


// Nav visibility arrives as a PROP from App, which owns the single fetch.
// Each of these components used to run its own copy of the hook — four
// independent fetches, four pieces of state — so the bottom bar and the swipe
// order could settle on different lists depending on which response landed
// first. One source of truth removes the race entirely.

// This nav is a FLAT array (unlike the desktop sidebar's grouped sections),
// so the filter is a plain one-level pass.
function applyHidden(nav, hidden) {
  if (!hidden.length) return nav;
  return nav.filter(function (it) { return hidden.indexOf(it.id) === -1; });
}

export default function TabletSidebar({ activePage, setActivePage, hidden }) {
  hidden = hidden || [];
  var [hoverId, setHoverId] = useState(null);
  var prevSection = null;

  return (
    <div style={{
      width: 62, height: '100%', background: '#070c1a',
      borderRight: '1px solid rgba(26,45,74,0.5)',
      display: 'flex', flexDirection: 'column', alignItems: 'center',
      paddingTop: 8, flexShrink: 0, zIndex: 50,
      WebkitUserSelect: 'none', userSelect: 'none',
    }}>
      <div onClick={function() { setActivePage('dashboard'); }}
        style={{ width: 40, height: 40, borderRadius: 10, marginBottom: 10, cursor: 'pointer', overflow: 'hidden', flexShrink: 0 }}>
        <img src="/algrok-logo.jpg" alt="A" style={{ width: 40, height: 40, display: 'block' }} />
      </div>

      <div style={{ flex: 1, overflowY: 'auto', overflowX: 'hidden', width: '100%', scrollbarWidth: 'none', msOverflowStyle: 'none' }}>
        <style>{'div::-webkit-scrollbar{display:none}'}</style>
        {applyHidden(NAV, hidden).map(function(item) {
          var active = activePage === item.id;
          var hovered = hoverId === item.id;
          var Icon = item.Icon;

          var showDivider = prevSection !== null && prevSection !== item.section;
          prevSection = item.section;

          return (
            <React.Fragment key={item.id}>
              {showDivider && <div style={{ width: 28, height: 1, background: 'rgba(26,45,74,0.4)', margin: '6px auto' }} />}
              <div
                onClick={function() { setActivePage(item.id); }}
                onMouseEnter={function() { setHoverId(item.id); }}
                onMouseLeave={function() { setHoverId(null); }}
                style={{
                  position: 'relative',
                  width: 46, height: 46, margin: '2px auto',
                  display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center',
                  borderRadius: 12, cursor: 'pointer',
                  background: active ? 'rgba(14,165,233,0.12)' : hovered ? 'rgba(26,45,74,0.3)' : 'transparent',
                  transition: 'background 0.15s',
                }}
              >
                {active && <div style={{
                  position: 'absolute', left: -8, top: 10, bottom: 10, width: 3,
                  borderRadius: '0 2px 2px 0', background: '#0ea5e9',
                }} />}

                <Icon size={20} color={active ? '#0ea5e9' : hovered ? '#e2e8f0' : '#4a6080'} strokeWidth={active ? 2.2 : 1.8} />
                <span style={{
                  fontSize: 8, fontWeight: 700, marginTop: 1,
                  color: active ? '#0ea5e9' : hovered ? '#8899aa' : '#3d5068',
                  letterSpacing: '0.2px', lineHeight: 1,
                }}>{item.label}</span>

                {hovered && !active && <div style={{
                  position: 'absolute', left: 54, top: '50%', transform: 'translateY(-50%)',
                  background: '#1a2d4a', color: '#e2e8f0', fontSize: 11, fontWeight: 700,
                  padding: '5px 10px', borderRadius: 6, whiteSpace: 'nowrap',
                  boxShadow: '0 4px 12px rgba(0,0,0,0.4)', zIndex: 999,
                  pointerEvents: 'none',
                }}>{item.label}</div>}
              </div>
            </React.Fragment>
          );
        })}
      </div>
    </div>
  );
}
